@if (!!user) {
  @if (matomoSafeHtml) {
    <div style="display: none" [innerHTML]="matomoSafeHtml">
      <!-- This is a placeholder for matomo scripts returned from server -->
    </div>
  }
  <message-handler/>
  @if (loaderService.loading$ | async) {
    <loader mode="transparent"/>
  }
  <div
    id="app-container"
    class="mat-typography mat-app-background"
    [ngClass]="isDarkTheme ? 'ideal-dark-theme' : 'ideal-light-theme'"
    >
    @if (routeData?.showHeader) {
      <app-header
        [layoutState]="layoutState()"
        (onNavToggle)="toggleNavigation()"
        (onThemeToggled)="toggleTheme($event)"
        (onLogout)="logout()"
        >
      </app-header>
    }
    @if (routeData?.showSidebar) {
      <app-sidebar
        [layoutState]="layoutState()"
        (onNavToggle)="toggleNavigation()"
        (onMobileNavToggle)="toggleMobileNavigation()"
        [@toggleAnimation]="layoutState().isIconView && !layoutState().isMobileView ? 'collapsed' : 'expanded'"
        [@mobileToggleAnimation]="layoutState().isMobileMenuOpen || !layoutState().isMobileView ? 'open' : 'closed'"
        >
      </app-sidebar>
    }
    <div id="main-content-container" class="content-container content position-relative"
      [class.quickView]="quickViewReady$ | async" cdkScrollable>
      <div class="mat-body" #content [style.padding-right]="contentPaddingRight$ | async">
        <router-outlet></router-outlet>
      </div>
      @if (quickViewModel$ | async; as quickModel) {
        <ng-container [idealClaims]="['View','Edit']">
          <div class="quick-view-container">
            <quick-view
              [dealName]="quickModel!.dealName"
              [client]="quickModel!.client"
              [primaryClient]="quickModel!.primaryClient"
              [contactId]="quickModel!.contactId"
              [entityId]="quickModel!.dealId"
              [entityType]="quickModel!.entityType!"
              [showQuickView]="true"
              (onOpenActivityModel)="quickModel.onOpenActivityModel!($event)"
              (onDeleteActivity)="quickModel.onDeleteActivity!($event)"
              (onClose)="quickViewService.close()">
            </quick-view>
          </div>
        </ng-container>
      }
      <idl-slide-panel-host />
      <mat-sidenav-container hasBackdrop="false">
        <mat-sidenav position="end" [opened]="!!sidenavService.template" [fixedInViewport]="true" [fixedTopGap]="68">
          <ng-container [ngTemplateOutlet]="sidenavService.template"></ng-container>
        </mat-sidenav>
      </mat-sidenav-container>
    </div>
  </div>
} @else {
  <loader/>
  <router-outlet></router-outlet>
}

